import React from 'react'
import ReactPlayer from "react-player";
function Reviews() {
    return (
        <div>
            <div className="album py-0">
                <div className="container">
                    <div className="row">
                        <div className="col-md-4 mt-3">
                            <div className=" mb-4">
                                <ReactPlayer className="mb-2" width="100%" height="100%" url="https://www.youtube.com/watch?v=rm--VE1xH54&t=4s" />
                                <div className="card-body">
                                    <div className='coloradd'>
                                        <h5 className="card-text mt-2 mb-1"> <b>PAUL'S HOTEL & BANQUET</b></h5>
                                        <h5 style={{ color: "#" }}> <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-geo-alt" viewBox="0 0 16 16">
                                            <path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A32 32 0 0 1 8 14.58a32 32 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10" />
                                            <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
                                        </svg> KRISHNAGAR</h5>
                                    </div>
                                    <p style={{ color: "grey" }} className="card-text">Hon'ble Sir Samir Paul 🙏 gave the best review to Tanmay Sarkar (MR. INDIAN CODER)  |   Website : <a href='https://www.paulshotel.com/' target='_blank' rel="noopener noreferrer">https://www.paulshotel.com/</a></p>


                                    <div className="d-flex justify-content-between align-items-center">



                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 mt-3">
                            <div className=" mb-4">
                                
                                <ReactPlayer className="mb-2" width="100%" height="100%" url="https://www.youtube.com/watch?v=wTeKfooBC7M" />

                                <div className="card-body">
                                    <div className='coloradd'>
                                        <h5 className="card-text mt-2 mb-1"> <b>M.B. DHAR AND SON JEWELLERS</b></h5>
                                        <h5 > <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-geo-alt" viewBox="0 0 16 16">
                                            <path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A32 32 0 0 1 8 14.58a32 32 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10" />
                                            <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
                                        </svg> BERHAMPORE</h5>

                                    </div>
                                    <p style={{ color: "grey" }} className="card-text">Honorable Sir Rajib Dhar Babu 🙏❤️( owner of M. B. Dhar & Son, Jewellers ) gave a very good review to  Tanmay Sarkar  ( MR. INDIAN CODER )  |   Website : <a href='https://www.mbdharandsonjewellers.com/' target='_blank' rel="noopener noreferrer">https://www.mbdharandsonjewellers.com/</a></p>


                                    <div className="d-flex justify-content-between align-items-center">



                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 mt-3">
                            <div className=" mb-4">
                                <ReactPlayer className="mb-2" width="100%" height="100%" url="https://www.youtube.com/watch?v=2INN8eQNLpM" />
                                <div className="card-body">
                                    <div className='coloradd'>
                                        <h5 className="card-text mt-2 mb-1"> <b>RUPA ECO BRICK</b></h5>
                                        <h5 > <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-geo-alt" viewBox="0 0 16 16">
                                            <path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A32 32 0 0 1 8 14.58a32 32 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10" />
                                            <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
                                        </svg> BERHAMPORE</h5>

                                    </div>
                                    <p style={{ color: "grey" }} className="card-text">Honorable Sir Debapriya Gope Babu 🙏❤️( owner of RUPA ECO BRICK ) gave a very good review to  Tanmay Sarkar  ( MR. INDIAN CODER )  |   Website : <a href='https://www.rupaecobrick.com/' target='_blank' rel="noopener noreferrer">https://www.rupaecobrick.com/</a></p>


                                    <div className="d-flex justify-content-between align-items-center">



                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 mt-3">
                            <div className=" mb-4">
                                <ReactPlayer className="mb-2 nio" width="100%" height="100%" url="https://www.youtube.com/watch?v=xK8PcAqfyeI" />
                                <div className="card-body">
                                    <div className='coloradd'>
                                        <h5 className="card-text mt-2 mb-1"> <b>HOTEL SANGAM</b></h5>
                                        <h5 > <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-geo-alt" viewBox="0 0 16 16">
                                            <path d="M12.166 8.94c-.524 1.062-1.234 2.12-1.96 3.07A32 32 0 0 1 8 14.58a32 32 0 0 1-2.206-2.57c-.726-.95-1.436-2.008-1.96-3.07C3.304 7.867 3 6.862 3 6a5 5 0 0 1 10 0c0 .862-.305 1.867-.834 2.94M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10" />
                                            <path d="M8 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
                                        </svg> BERHAMPORE</h5>

                                    </div>
                                    <p style={{ color: "grey" }} className="card-text">Honorable Mam Smt Sipra Guha Mam 🙏❤️( owner of Hotel Sangam ) gave a very good review to  Tanmay Sarkar  ( MR. INDIAN CODER )  |   Website : <a href='https://www.hotelsangams.com/' target='_blank' rel="noopener noreferrer">https://www.hotelsangams.com/</a></p>

                                    <div className="d-flex justify-content-between align-items-center">

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default Reviews